// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__QVeZy","title":"AfterFrontImage_title__29JeQ"};